<template>
    <v-container app :fluid="true" class="padding-top-0 pb-0">
        <v-row>            
            <v-col cols="7" class="padding-top-0 padding-bootom-0 pl-0">
                <products/>
            </v-col>
            <v-col cols="5" class="padding-top-0 pr-0 pb-0">                
                <cart/>
            </v-col>
        </v-row>
    </v-container>
    
</template>

<script>
import {mapState, mapActions} from 'vuex';
import Products from '@/components/Sales/Products.vue'
import Cart from '@/components/Sales/Cart.vue'

export default {
    name: 'Sales',
    components: {
        Cart,
        Products        
    },
    computed: {
        ...mapState('cash', [
            'cashCurrent'
        ])
    },
    methods: {
        ...mapActions('cash', [
            'getCashCurrent'
        ])
    },
    created () {
        this.getCashCurrent();
    }
}
</script>

<style>

</style>